import TextBubbles from '@home/components/TextBubbles';
import TableCommonHook from '@op/components/TableCommonHook';
import useLanguage from '@op/hooks/useLanguage';
import { formatDateFunc } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';
export default function Table(props: any) {
  const { data, maxHeight, columns } = props;
  const { formatMessage } = useLanguage();
  const tableColumns = useMemo(() => {
    const allColumns: Array<any> = columns.map(
      (item: { value: any; name?: any; formatValue?: any }) => {
        const { name, value, formatValue = reviewsFormat } = item;
        const header: string | React.ReactNode = formatMessage({ id: name });

        return {
          header,
          key: value,
          alight: 'right',
          width: 160,
          render: (cvm: any) => {
            return (
              <TextBubbles text={formatValue(cvm?.[item.value])} />
            );
          },
        };
      },
    );

    return [
      {
        header: formatMessage({ id: 'Date' }),
        key: 'time',
        align: 'left',
        width: 130,
        fixed: 'left',
        render: ({ time }: any) => {
          return time ? formatDateFunc('hourly')?.(time) || time : '-';
        },
      },
      ...allColumns,
    ];
  }, [columns, formatMessage]);

  return (
    <>
      <TableCommonHook
        recordKey={'playback_time'}
        columns={tableColumns}
        records={data}
        hasPageable={false}
        maxHeight={maxHeight}
        minWidth={'auto'}
      ></TableCommonHook>
    </>
  );
}
